<template>
    <div class="container_cool"  v-loading="login_loading" element-loading-text="页面加载中..."  element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="cool_bg" v-if="teacher_problems">
            <div class="cool_title">题目</div>
            <div class="cool_list">
                <div class="cool_item" v-for="(item,index) in examples" :key="index">
                    <div class="new_item">
                        <div class="title"><span class="index">{{index+1}}.</span>{{item.title}}</div>
                        <span v-if="item.status == 1" class="el-icon-time wait_icon"></span>
                        <span v-if="item.status == 2" class="el-icon-success success_icon"></span>
                    </div>
                    <div class="btns"><div class="click_btn" @click="startDati(item)">开始答题</div></div>
                </div>
            </div>
            <div class="clear_btns">
                <div class="cool_item">
                    <div></div>
                    <div class="btns"><div class="clear_btn" @click="clearCache">清理缓存</div></div>
                </div>
            </div>
        </div>    
        <div class="cool_bg" v-if="teacher_detail">
            <div class="cool_detail">
                <div class="detail_left">
                    <div class="detail_content">
                        <mavon-editor
                            :tabSize="4"
                            fontSize="20px"
                            :value="detail.title"
                            :subfield="false"
                            :defaultOpen="'preview'"
                            :toolbarsFlag="false"
                            :editable="false"
                            :scrollStyle="true"
                            :ishljs="true"
                            ref="md"
                            style="box-shadow: none !important;height:100%">
                        </mavon-editor>
                    </div>
                    <div class="detail_options">
                        <div class="options_pan" v-if="detail.type == 3">
                            <div><div class="icon_box" ><span class="el-icon-check"></span></div></div>
                            <div><div class="icon_box"><span class="el-icon-close"></span></div></div>
                        </div>
                        <div class="option_xuan" v-if="detail.type == 0">
                            <div v-for="(item,index) in detail.options" :key="index">
                                <div class="idx">{{item.idx}}:</div>
                                <div>
                                    <mavon-editor
                                        :tabSize="4"
                                        fontSize="20px"
                                        :value="item.content"
                                        :subfield="false"
                                        :defaultOpen="'preview'"
                                        :toolbarsFlag="false"
                                        :editable="false"
                                        :scrollStyle="true"
                                        :ishljs="true"
                                        ref="md"
                                        style="box-shadow: none !important;min-height:100px;max-height:110px;">
                                    </mavon-editor>
                                </div>
                            </div>
                        </div>
                        <div class="option_more_xuan" v-if="detail.type == 1">
                            <div v-for="(item,index) in detail.options" :key="index">
                                <div class="idx">{{item.idx}}:</div>
                                <!-- <div style="white-space: pre-wrap;margin-left:5px;">{{item.content}}</div> -->
                                <div>
                                    <mavon-editor
                                        :tabSize="4"
                                        fontSize="20px"
                                        :value="item.content"
                                        :subfield="false"
                                        :defaultOpen="'preview'"
                                        :toolbarsFlag="false"
                                        :editable="false"
                                        :scrollStyle="true"
                                        :ishljs="true"
                                        ref="md"
                                        style="box-shadow: none !important;min-height:100px;max-height:110px;">
                                    </mavon-editor>
                                </div>
                            </div>
                        </div>
                        <div class="option_tian" v-if="detail.type == 2">
                            <div class="tian_ipt_box" v-for="(item,index) in detail.ans_cnt" :key="index"><input class="tian_ipt" type="text" :placeholder="'('+ (index+1) +')'"></div>
                        </div>
                    </div>
                </div>
                <div class="detail_right">
                    <div class="click_back" v-if="is_ding" @click="detailBack">返回</div>
                    <div class="click_back" v-if="!is_ding" @click="getBack">返回</div>
                    <div class="click_names"  v-if="studentList.length > 0">
                        <div style="text-align: right;font-size: 16px; color: #f44; font-weight: bold;">未加入学生</div>
                        <div class="click_name" style="color: #4563ff;" v-for="(item,index) in studentList" :key="'studentList'+index">{{item.user_name}}</div>
                    </div>
                    <div class="click_num"  v-if="!is_ding">已加入：{{studentNumber}}人</div>
                    <div class="click_start" @click="detailStart" v-if="!is_ding">开始答题</div>
                </div>
            </div>
        </div>  
        
        <div class="zhuye_bg" v-if="teacher_start">
            <div class="cool_progress">
                <div class="progress_type_text">{{finish_number}} / {{studentNumber}}</div>
                <div class="progress_type_box"><el-progress :show-text="false" :text-inside="true" :stroke-width="28" :percentage="progress_status" status="success"></el-progress></div>
            </div>
            <div class="cool_start_time">{{ show_time_text }}</div>
            <div class="cool_kdt_jd">
                <img width="360px" src="../static/images/kddt.png" alt="">
                <div class="end_btn" @click="getEnd">结束答题</div>
            </div>
            <div class="cool_float_box">
                <div class="cool_fly_box"></div>
            </div>
        </div>   
        <div class="cool_end_bg" v-if="teacher_end">
           <div class="cool_end_pai"></div>
           <div class="cool_end_img">
               <div class="cool_end_answer">正确答案：
                   <span v-for="(item,index) in answers" :key="index" style="margin-right:10px;">
                     <span v-if="item == 0">对</span>
                     <span v-else-if="item == 1">错</span>
                     <span v-else>{{item}}</span>
                   </span>
               </div>
               <div class="cool_end_list">
                    <div class="cool_end_item" v-for="(item,index) in result" :key="index">
                        <div class="number" v-if="index == 0">
                            <img src="../static/images/1.png" alt="">
                        </div>
                        <div class="number" v-else-if="index == 1">
                            <img src="../static/images/2.png" alt="">
                        </div>
                        <div class="number" v-else-if="index == 2">
                            <img src="../static/images/3.png" alt="">
                        </div>
                        <div class="number" v-else><span>{{(index+1)}}}</span></div>
                        <div class="avatar"><img :src="item.avatar" alt=""></div>
                        <div class="name" style="width:100px;text-align: left;">{{item.name}}</div>
                        <div class="score">{{item.score}}</div>
                        <div class="jinbi"><img src="../static/images/jinbi.png" alt=""></div>
                        <div class="num">x{{item.coin}}</div>
                    </div>
               </div>
           </div> 
           <div class="cool_end_btns">
               <div class="end_bd_btn" @click="detailBack">返回</div>
               <div class="end_bd_btn" @click="getDings">订正</div>
           </div>
        </div>    
    </div>
</template>
<style>
    .option_xuan .markdown-body pre{
        padding: 0 !important;
    }   
    .option_xuan .v-note-wrapper .v-note-panel .v-note-show .v-show-content{
        height: inherit !important;
        padding: 0 !important;
    }
    .option_xuan .hljs{
        padding: 0 !important;
    }
    .option_xuan .markdown-body code{
        font-size: 18px;
    }
    .idx{
        font-size: 24px;
        font-weight: bold;
        margin-right: 10px;
    }
</style>
<script>
import $ from "jquery";
import "mavon-editor/dist/css/index.css";
import io from 'socket.io-client';

var timeOut = null;
export default {
    name: "cool",
    data() {
        return {
            login_loading:true,
            teacher_problems:false,
            teacher_detail:false,
            teacher_start:false,
            teacher_end:false,
            websock:null,
            token:'',
            lid:'',
            httpApi:'wss://datiadmin.kuding.cn',
            // httpApi:"ws://192.168.0.110:5200",
            examples:[],
            eid:0,
            detail:'',
            check:'',
            active:-2,
            xuan:[],
            studentNumber:0,
            studentList:[],
            start_time:'',
            xinmg:0,
            result:[],
            answers:[],
            is_ding:false,
            finish_number:0,
            progress_status:0,
            websocket:null,
            example_id:0,
            countNumber:0,
            show_time_text:'',
            un_join_users:[],
        };
    },
    created() {
        this.token = this.$route.query.token;
        this.lid = this.$route.query.lid;
    },
    mounted() {
        this.initWebscoket();
    },
    methods: {
        clearCache(){//清理缓存
            this.websocket.emit("clear");
        },
        clearData(data){
            let self = this;
            this.$message({
                type: "success",
                duration: 1000,
                message: '清理成功！',
                onClose:function(){
                    self.websocket.emit("lesson_detail");
                },
            });
        },
		initWebscoket() {
            let self = this;
            self.websocket = io(self.httpApi + '/dati', {
                query: "token=" + self.token + "&lesson_id=" + self.lid,
                transports: ['websocket', 'polling'],
                timeout: 5000,
                reconnectionDelay: 3000,
                reconnectionAttempts: 10,
            });
            self.websocket.io.on("reconnect_attempt", (attempt) => {
                if (attempt < 10) {
                    let data = '服务断开，正在重新尝试链接...'
                    self.$message({
                        type: "error",
                        duration: 2000,
                        message: data,
                    });
                    self.websocket.io.opts.extraHeaders = {
                        token: self.token,
                        lesson_id: self.lid
                    };
                } else {
                    let data = '服务重新链接失败';
                    self.$message({
                        type: "error",
                        duration: 2000,
                        message: data,
                    });
                }
            });
            self.websocket.io.on("reconnect", () => {
                let data = '重新链接成功！';
                self.$message({
                    type: "success",
                    duration: 2000,
                    message: data,
                });
            });
            self.websocket.on("error", (data) => {
                self.$message({
                    type: "error",
                    duration: 2000,
                    message: data,
                });
            });
         
            self.websocket.on("login_success", (data) => {
                self.loginSuccess(JSON.stringify(data))
            });
            self.websocket.on("on_lesson_detail", (data) => {
                self.initIndexData(JSON.stringify(data))
            });
            self.websocket.on("on_example_detail", (data) => {
                self.onExampleDetail(JSON.stringify(data))
            });
            self.websocket.on("on_open_example", (data) => {
                self.onOpenExample(JSON.stringify(data))
            });
            self.websocket.on("on_user_answer_progress", (data) => {
                self.onUserAnswerProgress(JSON.stringify(data))
            });
            self.websocket.on("on_cnt", (data) => {
                self.onCnt(JSON.stringify(data))
            });
            
            self.websocket.on("on_stop_answer", (data) => {
                self.onStopAnswer(JSON.stringify(data))
            });
            self.websocket.on("on_user_answer2teacher", (data) => {
                self.onUserAnswer2teacher(JSON.stringify(data))
            });
            self.websocket.on("on_room_num", (data) => {
                self.onRoomNum(JSON.stringify(data))
            });
            self.websocket.on("on_statistic", (data) => {
                self.onStatistic(JSON.stringify(data))
            });
            self.websocket.on("on_clear", (data) => {
                self.clearData(JSON.stringify(data))
            });
            self.websocket.on("on_correct", (data) => {
                self.onCorrect(JSON.stringify(data))
            });
            self.websocket.on("on_callback", (data) => {
                self.onCallback(JSON.stringify(data))
            });
        },
        onCallback(data){//返回
            this.finish_number = 0;
            let self = this;
            setTimeout(() => {
                self.websocket.emit("lesson_detail");
            }, 500);
        },
        loginSuccess(data){
            this.websocket.emit("lesson_detail");
        },
        onCorrect(data){
            this.finish_number = 0;
            this.is_ding = true;
            let self = this;
            setTimeout(() => {
                self.websocket.emit("example_detail",self.example_id);
            }, 500);
        },
        onStatistic(data){
            let dataResult = JSON.parse(data);
            this.answers = [];
            this.result = [];
            this.teacher_problems = false;
            this.teacher_detail = false;
            this.teacher_end = true;
            this.teacher_start = false;
            this.answers = dataResult.statistic.answers;
            this.result = dataResult.statistic.result;
        },
        onRoomNum(data){
            this.studentNumber = JSON.parse(data).count;
            this.studentList = JSON.parse(data).un_join_users;
        },
        initIndexData(data){
            this.examples = [];
            this.is_ding = false;
            this.teacher_problems = true;
            this.teacher_start = false;
            this.teacher_end = false;
            this.teacher_detail = false;
            this.examples = JSON.parse(data).lesson.examples;
            this.login_loading = false;
        },
        onExampleDetail(data){
            if(data && data != null){
                this.detail = JSON.parse(data).example;
                if(this.detail.status == 0){
                    this.teacher_problems = false;
                    this.teacher_start = false;
                    this.teacher_end = false;
                    this.teacher_detail = true;
                }else if(this.detail.status == 1){
                    this.teacher_problems = false;
                    this.teacher_start = true;
                    this.teacher_end = false;
                    this.teacher_detail = false;
                    this.websocket.emit("user_answer_progress",this.example_id);
                }else if(this.detail.status == 2){
                    this.teacher_problems = false;
                    this.teacher_start = false;
                    this.teacher_end = false;
                    this.teacher_detail = true;
                }
                this.$forceUpdate();
            }
        },
        onUserAnswerProgress(data){
            this.show_time_text = this.formatSeconds(JSON.parse(data).remain);
            this.countNumber = JSON.parse(data).remain;
            this.studentNumber = JSON.parse(data).user_count;
            this.finish_number = JSON.parse(data).answer_count;
            if(this.studentNumber > 0){
                this.progress_status = (this.finish_number / this.studentNumber) * 100;
            }else{
                this.progress_status = 0;
            }
            let self = this;
            setTimeout(() => {
                self.getShowTime();
            }, 1000);
        },
        onCnt(data){
            this.studentNumber = JSON.parse(data).user_count;
            this.finish_number = JSON.parse(data).answer_count;
            if(this.studentNumber > 0){
                this.progress_status = (this.finish_number / this.studentNumber) * 100;
            }else{
                this.progress_status = 0;
            }
        },
        onOpenExample(data){
            timeOut = null;
            this.teacher_problems = false;
            this.teacher_start = true;
            this.teacher_end = false;
            this.teacher_detail = false;
            this.websocket.emit("user_answer_progress",this.example_id);
        },
        getShowTime(){
            if(this.countNumber > 1){
                this.countNumber = this.countNumber - 1;
                this.show_time_text = this.formatSeconds(this.countNumber);
                let self = this;
                timeOut = setTimeout(() => {
                    self.getShowTime();
                }, 1000);
            }else{
                this.getEnd();
            }
        },
        formatSeconds(value) {
            var theTime = parseInt(value); // 秒
            var middle = 0; // 分
            var hour = 0; // 小时
            if (theTime > 60) {
                middle = parseInt(theTime / 60);
                theTime = parseInt(theTime % 60);
                if (middle > 60) {
                    hour = parseInt(middle / 60);
                    middle = parseInt(middle % 60);
                }
            } 
            var result = ''
            if (parseInt(theTime) >= 10) {
                result = "00" + ":" + parseInt(theTime);
            } else {
                result  = "00" + ":" + "0" + parseInt(theTime);
            }
            if (middle >= 0 && parseInt(theTime) >= 10) {
                if (parseInt(middle) >= 10) {
                    result = parseInt(middle) + ":" + parseInt(theTime);
                } else {
                    result = '0' + parseInt(middle) + ":" + parseInt(theTime);
                }
            } else {
                result = '0' + parseInt(middle) + ":" + "0" + parseInt(theTime);
            }
            return result;
        },
        onStopAnswer(data){
            this.teacher_problems = false;
            this.teacher_start = false;
            this.teacher_end = true;
            this.teacher_detail = false;
        },
        startDati(item){//开始答题
            this.example_id = item.id;
            this.websocket.emit("room_num");
            this.websocket.emit("example_detail",this.example_id);
        },
        getBack(){
            this.is_ding = false;
            this.teacher_problems = true;
            this.teacher_start = false;
            this.teacher_end = false;
            this.teacher_detail = false;
        },
        detailBack(){
            this.websocket.emit("callback");
        },
        detailStart(){
            this.websocket.emit("open_example",this.example_id);
        },
        // 学生提交完成通知
        onUserAnswer2teacher(event){
            let data = JSON.parse(event);
            let left = this.randomNum(20,80);
            let name = 'student_avatar'+this.xinmg;
            let html = '<img id="'+name+'" class="fly_img" style="left:'+left+'%;bottom:0%;" src="'+ data.avatar +'" alt="">';
            $('.cool_fly_box').append(html)
            this.flyImg(name,0,left,this.xinmg);
            this.xinmg = this.xinmg + 1;
        },
        randomNum(minNum,maxNum){ 
            switch(arguments.length){ 
                case 1: 
                    return parseInt(Math.random()*minNum+1,10); 
                break; 
                case 2: 
                    return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
                break; 
                    default: 
                        return 0; 
                    break; 
            } 
        },
        flyImg(name,num,left,xinmg){
            let x = num+1;
            console.log(x)
            $('#'+ name +'').css('bottom',x+'%')
            let self = this;
            setTimeout(function(){
                if(num < 100){
                    self.flyImg(name,x,left,xinmg);
                }else{
                    document.getElementById(name).remove();
                }
            },20)
        },

        //结束
        getEnd(){
            clearTimeout(timeOut);
            timeOut = null;
            this.show_time_text = '';
            this.countNumber = 0;
            this.websocket.emit("stop_answer",this.example_id);
        },
        getDings(){
            this.websocket.emit("correct",this.example_id);
        },
    },
       
};
</script>

<style scoped>
@import "../static/css/dati.css";
</style>
